import { inject } from '@angular/core';
import { CanActivateFn, CanMatchFn, Router } from '@angular/router';
import { RoutePathsEnum } from '@app/app.utils';
import { MaintenanceService } from '@shared/services/maintenance.service';
import { map } from 'rxjs/operators';

export const maintenanceModeGuard: CanMatchFn = () => {
  const router = inject(Router);
  return inject(MaintenanceService)
    .isMaintenanceModeEnabled()
    .pipe(map((enabled) => (enabled ? router.createUrlTree([RoutePathsEnum.Maintenance]) : true)));
};

export const maintenancePageGuard: CanActivateFn = () => {
  const router = inject(Router);
  return inject(MaintenanceService)
    .isMaintenanceModeEnabled()
    .pipe(map((enabled) => (enabled ? true : router.createUrlTree(['/']))));
};
